import { CoreLanguageType, LanguageType, toCoreLanguageType } from 'shared/src/types/languages.type';

/**
 * georacle.ai supports a smaller locale set than inceptionai's 24 core
 * languages, and its own middleware has no way to know which language an
 * inceptionai visitor is reading in — so map explicitly rather than let it
 * guess from cookies/Accept-Language on arrival.
 */
const GEORACLE_LOCALES: Partial<Record<CoreLanguageType, string>> = {
  en: 'en',
  fr: 'fr',
  es: 'es',
  de: 'de',
  it: 'it',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  hi: 'hi',
  ja: 'ja',
};

/** Builds a georacle.ai URL in the visitor's mapped locale, falling back to English. */
export function buildGeoracleUrl(
  path: string,
  languageCode: LanguageType,
  params: Record<string, string> = {},
): string {
  const locale = GEORACLE_LOCALES[toCoreLanguageType(languageCode)] ?? 'en';
  const query = new URLSearchParams(params).toString();
  const suffix = path ? `/${path}` : '';
  return `https://georacle.ai/${locale}${suffix}${query ? `?${query}` : ''}`;
}
